import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Loader, ModalGeneric } from 'ypf-pas-general-ui-components';

import useToast from '../../../../../hooks/useToast';
import { getDetailsHeader } from '../../../../../services/serviceRequest';
import { getDetailsMonthlyHeader } from '../../../../../services/monthlyServiceRequest';
import { assignmentTypeEnum, statusEnum, ubicationTypeEnum } from '../../../../../utils/dataStatus';
import {
  putUbicationDetail,
  putUbicationDetailOyM,
  putUbicationMonthlyDetail
} from '../../../../../adapters/requestServiceDetails/requestServiceDetailsAdapter';
import {
  updateimputationObjectMSDSApprover,
  updateImputationObjectSDSApprover
} from '../../../../../services/workReport';
import ImputationObjectDetail from '../../../../../page/ServiceRequest/DetailServiceRequest/UbicationCard/ImputationObjectDetail/ImputationObjectDetail';
import MonthlyImputationObject from '../../../../WorkReports/MonthlyWorkReport/MonthlyImputationObject/MonthlyImputationObject';

const ModalIO = (props) => {
  const {
    show,
    onHide,
    detailsApproval,
    onEdit,
    form,
    tpyeAndObjectImputationPermissions,
    disabledEditStateCancelOrFinish,
    setHasError
  } = props;

  const [details, setDetails] = useState();
  const [loading, setLoading] = useState(true);
  const [disabledActions, setDisabledActions] = useState(false);
  const { setNewToast } = useToast();

  const finalStatus =
    details?.estadoEnum === statusEnum.cancelada || details?.estadoEnum === statusEnum.finalizada;

  const getDetailsHeaders = async () => {
    try {
      setLoading(true);

      const detailsHeader =
        detailsApproval?.tipoAsignacion !== assignmentTypeEnum.Mensualizada
          ? await getDetailsHeader(detailsApproval?.idSolicitud)
          : await getDetailsMonthlyHeader(detailsApproval?.idSolicitud);

      const isOyM = detailsHeader?.esOyM;

      setDetails({
        ...detailsHeader,
        isOyM,
        ubicationId: detailsApproval?.ubicacionId,
        ubicationType: { id: detailsApproval?.tipoUbicacionEnum },
        tipoUbicacionEnum: detailsApproval?.tipoUbicacionEnum
      });

      if (detailsHeader) {
        setLoading(false);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }

    return null;
  };

  useEffect(() => {
    if (detailsApproval?.idSolicitud) getDetailsHeaders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailsApproval?.idSolicitud]);

  const updateWellsWithModifiedProps = (originalWells, copyWells) =>
    originalWells
      ?.filter((originalWell, index) => {
        if (!copyWells?.length) return false;
        const modifiedWell = copyWells[index];

        const isImputationObjectModified =
          originalWell?.imputationObject?.id !== modifiedWell?.imputationObject?.id;
        const isImputationTypeModified =
          originalWell?.imputationType?.id !== modifiedWell?.imputationType?.id;

        return isImputationObjectModified || isImputationTypeModified;
      })
      .map((originalWell, index) => {
        const modifiedWell = copyWells[index];
        const updatedWell = { ...originalWell };

        if (originalWell?.socCode !== modifiedWell?.socCode?.nombre) {
          updatedWell.socCode = modifiedWell?.socCode?.nombre || originalWell.socCode;
        }
        if (originalWell?.logisticCenter !== modifiedWell?.logisticCenter?.nombre) {
          updatedWell.logisticCenter =
            modifiedWell?.logisticCenter?.nombre || originalWell.logisticCenter;
        }

        return updatedWell;
      });

  const createBodyPostArray = (wellsArray, pozoIdManagment) =>
    wellsArray.map((well) => ({
      ...(pozoIdManagment && {
        pozoId: well?.well?.id
      }),
      ubicacion: well?.well?.nombre || details?.ubicacionStr,
      sociedad: well?.socCode,
      centro: well?.logisticCenter?.length > 1 ? String(well?.logisticCenter) : null,
      tipoImputacionId: well?.imputationType?.value,
      objetoImputacion: {
        id: well.imputationObject?.id,
        nombre: well.imputationObject?.nombre.split(' | ')[0]
      }
    }));

  const updateData = async () => {
    setLoading(true);
    try {
      const originalWells = form?.current?.values?.imputationObject?.wells;
      const copyWells = form?.current?.values?.imputationObject?.copyWells;
      const updatedWellsArray = updateWellsWithModifiedProps(originalWells, copyWells);
      const imputationObjectValues = form?.current?.values?.imputationObject;
      let data;

      if (imputationObjectValues?.esSoloAprobador) {
        const isLocationOrWell =
          detailsApproval?.tipoUbicacionEnum === ubicationTypeEnum.pozo ||
          detailsApproval?.tipoUbicacionEnum === ubicationTypeEnum.locacion;

        const bodyPostWellsArray = createBodyPostArray(updatedWellsArray, isLocationOrWell);

        await updateImputationObjectSDSApprover(details?.id, {
          objetosImputacion: bodyPostWellsArray
        });
        onEdit();
        onHide();
        setNewToast({
          type: 'SUCCESS',
          message: 'Se ha actualizado correctamente'
        });
        setLoading(false);
      } else if (details?.isOyM) {
        data = await putUbicationDetailOyM(originalWells, details?.id);
      } else {
        data = await putUbicationDetail(originalWells, details?.id);
      }
      if (data) {
        onEdit();
        onHide();
        setNewToast({
          type: 'SUCCESS',
          message: `${data?.mensaje}`
        });
        setLoading(false);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
      setLoading(false);
    }
  };

  const createBodyPostArrayMsds = (wellsArray, pozoIdManagment) =>
    wellsArray.map((well) => ({
      ...(pozoIdManagment && {
        pozoId: well?.well?.id
      }),
      sociedad: well?.socCode,
      centro: well?.logisticCenter?.length > 1 ? String(well?.logisticCenter) : null,
      tipoImputacion: well?.imputationType?.value,
      objetoImputacion: {
        id: well?.imputationObject?.id,
        nombre: well?.imputationObject?.nombre.split(' ')[0]
      }
    }));

  const handleUpdateImputationObject = async () => {
    const originalWells = form?.current?.values?.imputationObject?.wells;
    const copyWells = form?.current?.values?.imputationObject?.copyWells;
    const updatedWellsArray = updateWellsWithModifiedProps(originalWells, copyWells);
    const imputationObjectValues = form?.current?.values?.imputationObject;

    if (finalStatus) {
      onHide();
    } else {
      setLoading(true);

      if (imputationObjectValues?.esSoloAprobador) {
        const isLocationOrWell =
          detailsApproval?.tipoUbicacionEnum === ubicationTypeEnum.pozo ||
          detailsApproval?.tipoUbicacionEnum === ubicationTypeEnum.locacion;

        const bodyPostWellsArray = createBodyPostArrayMsds(updatedWellsArray, isLocationOrWell);

        updateimputationObjectMSDSApprover(
          { idSolicitud: detailsApproval?.idSolicitud, idUbicacion: detailsApproval?.ubicacionId },
          bodyPostWellsArray
        )
          .then(() => {
            setLoading(false);
            onEdit();
            onHide();
            setNewToast({
              type: 'SUCCESS',
              message: 'Los cambios fueron guardados correctamente'
            });
          })
          .catch((err) => {
            setLoading(false);
            setNewToast({
              type: 'ERROR',
              message: err.message
            });
          });
      } else {
        putUbicationMonthlyDetail({
          wells: originalWells,
          requestId: detailsApproval?.ubicacionId,
          isOyM: details?.isOyM
        })
          .then(() => {
            setLoading(false);
            onEdit();
            onHide();
            setNewToast({
              type: 'SUCCESS',
              message: 'Los cambios fueron guardados correctamente'
            });
          })
          .catch((err) => {
            setLoading(false);
            setNewToast({
              type: 'ERROR',
              message: err.message
            });
          });
      }
    }
  };

  const renderImputationForm = () => {
    if (!details) {
      return <></>;
    }

    if (details?.tipoAsignacion?.id === assignmentTypeEnum.Mensualizada) {
      return (
        <MonthlyImputationObject
          canAddWellToImputationObject={false}
          canEditImputationObject
          data={details}
          disabledDeleteWell
          form={form}
          idSolicitud={detailsApproval?.idSolicitud}
          isOyM={details?.isOyM}
          setDisabledActions={setDisabledActions}
          setHasError={setHasError}
          setLoading={setLoading}
        />
      );
    }

    return (
      <ImputationObjectDetail
        details={details}
        disabledDeleteWell
        disabledEditStateCancelOrFinish={finalStatus}
        form={form}
        idSolicitud={detailsApproval?.idSolicitud}
        isOyM={details?.isOyM}
        setDisabledActions={setDisabledActions}
        setHasError={setHasError}
        tpyeAndObjectImputationPermissions={tpyeAndObjectImputationPermissions}
      />
    );
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={onHide}
      primaryAction={
        details?.tipoAsignacion?.id === assignmentTypeEnum.Mensualizada
          ? handleUpdateImputationObject
          : updateData
      }
      primaryActionDisabled={disabledEditStateCancelOrFinish || disabledActions}
      primaryActionLabel="Aceptar"
      secondaryAction={onHide}
      secondaryActionLabel="Salir"
      show={show}
      size="xl"
      title="Detalles del tipo y objeto de imputación"
    >
      {loading && <Loader show={loading} text="CARGANDO ..." />}
      {renderImputationForm()}
    </ModalGeneric>
  );
};

ModalIO.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  detailsApproval: PropTypes.shape({
    idSolicitud: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    tipoAsignacion: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape({
        id: PropTypes.number
      })
    ]),
    ubicacionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isOyM: PropTypes.bool,
    tipoUbicacionEnum: PropTypes.number
  }).isRequired,
  form: PropTypes.shape({
    current: PropTypes.shape({
      values: PropTypes.shape({
        imputationObject: PropTypes.shape({
          id: PropTypes.number.isRequired,
          nombre: PropTypes.string.isRequired,
          descripcion: PropTypes.string.isRequired,
          value: PropTypes.number.isRequired,
          label: PropTypes.string.isRequired,
          wells: PropTypes.arrayOf(PropTypes.shape({})),
          copyWells: PropTypes.arrayOf(PropTypes.shape({}))
        }),
        errors: PropTypes.bool,
        touched: PropTypes.bool
      })
    })
  }).isRequired,
  tpyeAndObjectImputationPermissions: PropTypes.shape({
    editObjectImputation: PropTypes.bool,
    editWells: PropTypes.bool
  }),
  disabledEditStateCancelOrFinish: PropTypes.bool,
  setHasError: PropTypes.func.isRequired,
  onEdit: PropTypes.func
};

ModalIO.defaultProps = {
  show: false,
  tpyeAndObjectImputationPermissions: null,
  disabledEditStateCancelOrFinish: false,
  onEdit: () => {}
};
export default ModalIO;
